import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { Prompt } from 'react-router'

import { GenericErrorScreen, GenericSimpleButton } from 'com-gyf-webcore-userinterfacecomponents';
import ProcessManager from '../../../Common/Managers/ProcessManager';

import GenericModal from '../../../Packages/SharedComponents/Com.Gyf.WebCore.GenericModal.jsx';
import MessagePopup from '../../../Packages/SharedComponents/Com.Gyf.WebCore.MessagePopup.jsx';

import Title from './Title.jsx';
import Header from './Header.jsx';
import DetalleConfiguracionPersonalizada from './DetalleConfiguracionPersonalizada.jsx';
import DetalleConfiguracionActiveDirectory from './DetalleConfiguracionActiveDirectory.jsx';

class ConfiguracionSesionEditar extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {

        window.onbeforeunload = function (event) {
            if (sessionStorage.getItem('PantallaCambios') == "true") {
                return "¿Quieres salir de este sitio web? Es posible que los cambios no se guarden.";
            }
        }

        this.props.getScreenData(this.props.currentScope);
    }

    componentWillReceiveProps(nextProps) {
        this.setState(nextProps);

        if (!nextProps.data.messageHidden) {
            setTimeout(() => {
                this.props.hidePopUp();
            }, 7000);
        }
    }

    componentWillUnmount() {
        this.props.resetState();
    }

    render() {
        let component = null;
        let spinner = null;

        if (this.props.data.isFetching == true)
            spinner = <div className="loading">Loading&#8230;</div>

        if (this.props.data.isFetching == true)
            return spinner;

        if(this.props.data.redirect == true)
        return <Redirect to={ProcessManager.GetNextStep("ConfiguracionSesionEditar", "ROUTE_TO_CONFIGSESIONVISTA_VIEW")} push />

        //if (this.props.data.functions != undefined && this.props.data.functions.length > 0) {

        let functions = this.props.data.functions;

        //if (functions.Consulta == true) {
        //if (this.props.data.configuration == undefined)
        //        return spinner;

        component = (
            <div className="container-fluid concierge">
                {spinner}         

                <div className="container-fluid concierge">
                    <Title titulo1={'Editar configuración de sesiones'} titulo2={''} />

                    <Header functions={this.props.data.functions}
                        guardarConfiguracion={this.props.guardarConfiguracion}
                        setRedirectOk={this.props.setRedirectOk}
                        configuracion={this.props.data} />

                    <div className="bottom-separator-xxs">
                        <MessagePopup isHidden={this.props.data.messageHidden}
                            message={this.props.data.message}
                            classMessage={this.props.data.messageClass} />
                    </div>

                    <h3>Administrar configuración de sesiones de modo:</h3>

                    <DetalleConfiguracionActiveDirectory
                        maxDiasInactividad={this.props.data.maxDiasInactividad}
                        minutosPermitidosInactividad={this.props.data.minutosPermitidosInactividad}
                        vincularGrupoWindows={this.props.data.vincularGrupoWindows}
                        altaAutomatica={this.props.data.altaAutomatica}
                        soloUsuarioLoggeado={this.props.data.soloUsuarioLoggeado}
                        solicitarContrasenia={this.props.data.solicitarContrasenia}
                        tipoConfiguracion={this.props.data.tipoConfiguracion}
                        checkboxChangeState={this.props.checkboxChangeState}
                        maxDiasInactividadCheck={this.props.data.maxDiasInactividadCheck}
                        minutosPermitidosInactividadCheck={this.props.data.minutosPermitidosInactividadCheck}
                        configurationTypeChange={this.props.configurationTypeChange}
                        radioButtonChange={this.props.radioButtonChange}
                        textChangeState={this.props.textChangeState}/>

                    <DetalleConfiguracionPersonalizada alfabetica={this.props.data.alfabetica}
                        cantIntentosFallidos={this.props.data.cantIntentosFallidos}
                        cantidadRepeticiones={this.props.data.cantidadRepeticiones}
                        caracteresEspeciales={this.props.data.caracteresEspeciales}
                        caracteresMinimos={this.props.data.caracteresMinimos}
                        caseSensitive={this.props.data.caseSensitive}
                        maxDiasCaducidad={this.props.data.maxDiasCaducidad}
                        maxDiasInactividad={this.props.data.maxDiasInactividad}
                        minutosPermitidosInactividad={this.props.data.minutosPermitidosInactividad}
                        numerica={this.props.data.numerica}
                        permiteCaracteresIguales={this.props.data.permiteCaracteresIguales}
                        permiteLetrasConsecutivas={this.props.data.permiteLetrasConsecutivas}
                        permiteNrosConsecutivos={this.props.data.permiteNrosConsecutivos}
                        permiteRepetirPosicion={this.props.data.permiteRepetirPosicion}
                        tipoConfiguracion={this.props.data.tipoConfiguracion}
                        plataformas={this.props.data.plataformas}
                        configurationTypeChange={this.props.configurationTypeChange}
                        checkboxChangeState={this.props.checkboxChangeState}
                        textChangeState={this.props.textChangeState}
                        plataformaValueChange={this.props.plataformaValueChange}
                        radioButtonChangeContrasenia={this.props.radioButtonChangeContrasenia}/>
                </div>

                <GenericModal type="ALL_CUSTOM"
                            className="modal fade-out"
                            id="discardChangesModal"
                            screenSize="modal-dialog modal-generic"
                            header={
                                <h2 className="modal-title">Descartar cambios</h2>}
                            footer={
                                <div className="row">
                                    <div className="col-xs-4">
                                        <button className="btn btn-primary btn-cta" onClick={() => this.props.setRedirectOk()}>Descartar Cambios</button>
                                    </div>
                                    <div className="col-xs-8">
                                        <GenericSimpleButton text="Cancelar" dataDismiss={"modal"} buttonClass="btn btn-default btn-secondary" />
                                    </div>
                                </div>}
                            body={<p>Usted tiene cambios sin guardar ¿Quiere descartarlos y volver a la pantalla de perfiles y permisos?</p>} />

            </div>
        );


        //} else {
        //    let values = {
        //        message: "Disculpe, no tiene permisos para acceder a esta pantalla.",
        //        linkMessage: "Volver a mi pagina de inicio"
        //    };

        //component = <GenericErrorScreen data={values} />;
        //}

        return (component);
        //} else {
        //    return null;
        //}
    }
}

export default ConfiguracionSesionEditar;